import { useCallback, useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router-dom";



import { DashboardHeader } from "./DashboardHeader";

import { DashboardSidebar } from "./DashboardSidebar";

import { ElevatedRiskProtectionBanner } from "./ElevatedRiskProtectionBanner";

import JesseRedactionConsentModal from "../jesse/JesseRedactionConsentModal";

import JesseSourceAccessGate from "../jesse/JesseSourceAccessGate";

import AddPropertyPopup from "../userProfile/add-property";

import { AddPropertyLauncherProvider } from "./addPropertyLauncherContext";

import { userSettingsAction } from "../../redux/slices/user/userSettingSlice";

import { propertiesAction } from "../../redux/slices/properties/propertiesSlice";

import { PER_PAGE } from "../helpers/constants";

import { isIosApp } from "../helpers/utils";

import { ensureCallPilotChatbotReady } from "../helpers/callPilotChatbot";



const MOBILE_SIDEBAR_BREAKPOINT = 699;



export const DashboardLayout = ({ isTailwindComponent = false, comp }) => {

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const location = useLocation();

  const [isBelow699, setIsBelow699] = useState(false);

  const [isIosNativeApp, setIsIosNativeApp] = useState(false);

  const [isAddPropertyModalOpen, setIsAddPropertyModalOpen] = useState(false);

  const isSidebarOpen = useSelector(

    (state: any) => state?.userSettings?.isSidebarOpen ?? true,

  );

  const { loginAsSpouse: isSecondaryUser, parent_id } = useSelector(

    (state: {

      userProfile?: { loginAsSpouse?: boolean; parent_id?: number };

    }) => state?.userProfile ?? {},

  );

  const userProfileDetails = useSelector(

    (state: {

      userProfile?: { userProfileDetails?: { data?: Record<string, unknown> } };

    }) => state?.userProfile?.userProfileDetails,

  );

  const userData = userProfileDetails?.data;



  useEffect(() => {

    setIsIosNativeApp(isIosApp());

  }, []);



  useEffect(() => {

    if (typeof window === "undefined") return;



    const mediaQuery = window.matchMedia("(max-width: 698px)");



    const apply = () => {

      setIsBelow699(mediaQuery.matches);

      if (mediaQuery.matches) {

        dispatch(userSettingsAction.setSidebarOpen(false));

      }

    };



    apply();



    if (typeof mediaQuery.addEventListener === "function") {

      mediaQuery.addEventListener("change", apply);

      return () => mediaQuery.removeEventListener("change", apply);

    }



    // Safari fallback

    mediaQuery.addListener(apply);

    return () => mediaQuery.removeListener(apply);

  }, [dispatch]);



  useEffect(() => {

    void ensureCallPilotChatbotReady({ hideLauncher: true });

  }, []);



  const refreshPropertyList = useCallback(() => {

    let url = "customer/properties-v1";

    if (isSecondaryUser && parent_id) {

      url = `customer/properties-v1/${parent_id}`;

    }

    dispatch(

      propertiesAction.fetchPropertyList({

        url,

        data: {

          limit: PER_PAGE,

          offset: 0,

        },

        token: true,

      }),

    );

  }, [dispatch, isSecondaryUser, parent_id]);



  const handleAddPropertyClick = useCallback(() => {

    // Open modal before closing sidebar so it survives mobile sidebar unmount.

    setIsAddPropertyModalOpen(true);



    if (

      typeof window !== "undefined" &&

      window.innerWidth < MOBILE_SIDEBAR_BREAKPOINT

    ) {

      dispatch(userSettingsAction.setSidebarOpen(false));

    }



    if (!location.pathname.startsWith("/properties")) {

      navigate("/properties");

    }

  }, [dispatch, location.pathname, navigate]);



  const shouldRenderSidebar = !isBelow699 || isSidebarOpen;

  const showIosAddProperty = isIosNativeApp && !isSecondaryUser;

  const addPropertyLauncher = useMemo(

    () => ({ available: showIosAddProperty, open: handleAddPropertyClick }),

    [handleAddPropertyClick, showIosAddProperty],

  );



  return (

    <div className={`min-h-screen bg-background tailwind_component`}>

      {shouldRenderSidebar ? (

        <DashboardSidebar

          isSidebarOpen={isSidebarOpen}

          showIosAddProperty={showIosAddProperty}

          onAddPropertyClick={handleAddPropertyClick}

        />

      ) : null}

      <DashboardHeader

        isSidebarOpen={isSidebarOpen}

        onMenuClick={() => dispatch(userSettingsAction.toggleSidebar())}

      />

      <div

        className={`pt-16 min-h-screen transition-all duration-200 ${

          isBelow699 ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"

        }`}

        onClick={() => {

          if (typeof window !== "undefined" && window.innerWidth < 699) {

            dispatch(userSettingsAction.setSidebarOpen(false));

          }

        }}

      >

        <ElevatedRiskProtectionBanner />

        <JesseRedactionConsentModal />

        <JesseSourceAccessGate />

        <div className={`${isBelow699 ? "p-3" : "p-6"}`}>

          <AddPropertyLauncherProvider value={addPropertyLauncher}>

            {comp}

          </AddPropertyLauncherProvider>

        </div>

      </div>



      {showIosAddProperty ? (

        <AddPropertyPopup

          showBtn={false}

          initialyAddPropertyModal={isAddPropertyModalOpen}

          setIsAddPropertyModalOpen={setIsAddPropertyModalOpen}

          getPropertyList={refreshPropertyList}

          isUserCreateProperty={true}

          callListingAPI={false}

          user_id={userData?.user_id as number | undefined}

          userEmail={userData?.email as string | undefined}

          isTailwindComponent={isTailwindComponent}

        />

      ) : null}

    </div>

  );

};

